import { FC, PropsWithChildren } from 'react';

import { CSSProperties, TColorProp } from 'styled-components';

import { inter } from '~/common/styles/fonts';

import { Container, TParagraphSize } from './styles';

interface IParagraphProps extends PropsWithChildren {
  size: TParagraphSize;
  color?: TColorProp;
  style?: CSSProperties;
  href?: string;
}

export const Paragraph: FC<IParagraphProps> = ({
  size,
  color = 'neutral.100',
  children,
  style,
  href,
}) => {
  return (
    <Container
      $size={size}
      $color={color}
      className={inter.className}
      style={style}
      {...(href && {
        as: 'a',
        href,
      })}
    >
      {children}
    </Container>
  );
};
